function formatPrice(price) {
	if (price === null || price === undefined || price === "") return "";

	const numeric =
		typeof price === "number"
			? price
			: Number(String(price).replace(/\s/g, "").replace(",", "."));
	if (!Number.isFinite(numeric)) return "";

	return numeric
		.toFixed(2) // Optional, to fix decimal points if needed
		.split(".") // Split integer and decimal parts
		.map((part, index) =>
			index === 0 ? part.replace(/\B(?=(\d{3})+(?!\d))/g, " ") : part
		) // Add space every 3 digits in the integer part
		.join(","); // Join the parts back together
}

export default formatPrice;
